<template>
  <section class="slider-container">

    <slick :options="slickOptions" ref="slider">
      <slot></slot>
    </slick>

    <div class="slider-arrows" v-if="!arrows">
      <a class="slider-arrow prev" @click="prev()"><i class="fa fa-angle-up" aria-hidden="true"></i></a>
      <a class="slider-arrow next" @click="next()"><i class="fa fa-angle-down" aria-hidden="true"></i></a>
    </div>

  </section>
</template>

<script>
  import Slick from 'vue-slick';
  import '~/node_modules/slick-carousel/slick/slick.css';

  export default {
    props: {
      autoplay: { default: false },
      arrows: { default: false },
      autoplaySpeed: { default: 2000 },
      adaptiveHeight: { default: true },
    },
    data() {
      return {
        slickOptions: {
          arrows: this.arrows,
          nextArrow: '<i class="fa fa-angle-left fa-2x fa-arrows slick-next" aria-hidden="true"></i>',
          prevArrow:'<i class="fa fa-angle-right fa-2x fa-arrows slick-prev" aria-hidden="true"></i>',
          fade: true,
          autoplay: this.autoplay,
          autoplaySpeed: this.autoplaySpeed,
          adaptiveHeight: this.adaptiveHeight,
          swipe: false,
          responsive: [
            {
              breakpoint: 995,
              settings: {
               // arrows: true,
              }
            }
          ]
        },
      };
    },
    methods: {
      next() {
        this.$refs.slider.next();
      },
      prev() {
        this.$refs.slider.prev();
      },
      rebuild() {
        const that = this;
        if (that.$refs.slider) {
          that.$refs.slider.destroy();
          that.$nextTick(() => {
            if (that.$refs.slider) {
              that.$refs.slider.create();
            }
          });
        }
      },
    },
    mounted() {
      const that = this;
      setTimeout(function () {
        that.rebuild();
      }, 500)
    },
    components: {
      Slick,
    }
  }
</script>

<style lang="scss">

  .slider-container {
    min-width: 0;
    min-height: 0;

    width: 100%;
  //  overflow: hidden;
    position: relative;

    .slick-slider {
   //   overflow: hidden;
      width: 100%;
      // hack
      //max-width: calc(100vw - 30px);
    }

    .slick-track {
      display: flex;display: -ms-flexbox;
      align-items: stretch;
      .slick-slide {
        height: auto;
        display: flex;display: -ms-flexbox;
        flex-flow: column nowrap;
        & > div {
          flex: 1 0 auto;
          display: flex;display: -ms-flexbox;
          flex-flow: column nowrap;
        }
      }
    }
    .slider-arrows {
      position: absolute;
      right: 25px;
      top: 540px;
      @media(max-width: $media_md) {
        display: none;
      }
      .fa {
        border: 1px solid;
        border-radius: 30px;
        width: 30px;
        height: 30px;
        text-align: center;
        font-size: 1.7em;
      }
    //  display: flex;display: -ms-flexbox;
    //  flex-flow: row nowrap;
     // justify-content: space-between; -ms-flex-pack: justify;
     // align-items: center;
      padding:5px 0;


      .slider-arrow {
        color: $color-text;
        text-decoration: none;
        text-transform: uppercase;
        line-height: 40px;
        position: relative;
        cursor: pointer;
        display: flex;display: -ms-flexbox;
        align-content: center;
        justify-content: center;
        margin-bottom: 10px;
        @include ease(all, 0s);
        &.prev {

          &:hover {
            color: rgba($color-text,0.5);
          }
        }
        &.next {

          &:hover {
            color: rgba($color-text,0.5);
          }
        }
      }
    }

     .fa-arrows {
       position: absolute;
       z-index: 100;
       top: 0;
       bottom: 0;
       font-size: 4em;
       display: flex;display: -ms-flexbox;
       align-items: center;
       color: rgba($color-black,0.6);
       -webkit-text-stroke: 3px white;
       cursor: pointer;
       &.fa-angle-left {
         left: -40px;
       }
       &.fa-angle-right {
         right: -40px;
       }
       &:hover {
         opacity: 0.5;
       }
       @media(max-width: $media_xs) {
        // top: 22%;
       }
       @media (max-width: 400px) {
        // top: 14%;
       }
     }
  }
</style>



// WEBPACK FOOTER //
// components/shared/sliders/Slider.vue